import _ from 'lodash';
import moment from 'moment';
import { sessionStorage } from '../../../utils/webstorage';
import store from '../../../config/redux/store';
import initialState from './initialState';
import { FilterSet, RequestState } from '../types';

const STORAGE_REQUEST_KEY = 'search_request';
const requestStoreVersion = '1.0';
let unsubscribeStore: any;

type StoredRequest = Omit<RequestState, 'arrival' | 'durationOfStay' | 'filterSet'> & {
  arrival: string | null;
  durationOfStay: number | null;
  filterSet: FilterSet;
  version?: string;
};

function saveRequest(request = store.getState().request): void {
  const requestToStore: StoredRequest = {
    ...request,
    arrival: request.arrival ? request.arrival.toISOString() : null,
    durationOfStay: request.durationOfStay != null ? request.durationOfStay : null,
    filterSet: {
      ...request.filterSet,
    },
    version: requestStoreVersion,
  };
  const stringifiedRequest = JSON.stringify(requestToStore);
  sessionStorage().setItem(STORAGE_REQUEST_KEY, stringifiedRequest);
}

export function loadRequest(): RequestState | null {
  const storedRequest = sessionStorage().getItem(STORAGE_REQUEST_KEY);
  if (!storedRequest) {
    return null;
  }
  const parsedRequest = JSON.parse(storedRequest) as StoredRequest;

  if (parsedRequest.version !== requestStoreVersion) {
    return null;
  }
  delete parsedRequest.version;

  return {
    ...parsedRequest,
    arrival: parsedRequest.arrival ? moment(parsedRequest.arrival) : initialState.arrival,
    durationOfStay: parsedRequest.durationOfStay != null ? parsedRequest.durationOfStay : null,
    filterSet: {
      ...parsedRequest.filterSet,
    },
  };
}

const hasRequestChanged = ((): (() => boolean) => {
  let lastState: RequestState;

  return (): boolean => {
    const currState = store.getState().request;
    const val = !lastState || !_.isEqual(lastState, currState);
    lastState = currState;
    return val;
  };
})();

function isSubscribed(): boolean {
  return !!unsubscribeStore;
}

function unsyncRequestStore(): void {
  if (isSubscribed()) {
    unsubscribeStore();
    unsubscribeStore = null;
  }
}

function syncRequestStore(): void {
  if (store && !isSubscribed()) {
    unsubscribeStore = store.subscribe(() => {
      if (hasRequestChanged()) saveRequest();
    });
  }
}

export function autoSyncRequestStore(): void {
  if (!isSubscribed()) {
    _.defer(syncRequestStore);
    window.addEventListener('unload', unsyncRequestStore);
  }
}
